import AddToCartForm
    from '../../../../../../../ProductDetailPage/Theme/default/components/molecules/add-to-cart-form/add-to-cart-form';
import {
    updateRecommendationApiUrl
} from 'PyzShopUi/scripts/product-detail-page/includes/productDetailPageUrlParamHelper';

export const changeAddToCartButtonActionSku = (addToCartFormElement: HTMLFormElement, sku: string): void => {
    const addToCartUrl = addToCartFormElement.dataset[AddToCartForm.DATA_ADD_TO_CART_URL];
    const match = /\/f?\d+/.exec(addToCartUrl);
    addToCartFormElement.dataset[AddToCartForm.DATA_ADD_TO_CART_URL] = addToCartUrl.substring(match.index, 0) + '/' + sku;
}

export const updateAddToCartButtonRecommendationUrl = (addToCartFormElement: HTMLFormElement, sku: string): void => {
    addToCartFormElement.dataset[AddToCartForm.DATA_RECOMMENDATION_API_URL] = updateRecommendationApiUrl(
        addToCartFormElement.dataset[AddToCartForm.DATA_RECOMMENDATION_API_URL],
        sku
    );
}

export const enableAddToCartButton = (addToCartFormElement: HTMLFormElement): void => {
    const addToCartButton: HTMLButtonElement = addToCartFormElement.querySelector('.submit-order');
    addToCartButton.disabled = false;
    addToCartButton.classList.remove('disabled');
    const quantityInput: HTMLInputElement = addToCartFormElement.querySelector('.article__order-qty');
    quantityInput.disabled = false;
    quantityInput.parentElement.classList.remove('mdc-text-field--disabled');
}

export const disableAddToCartButton = (addToCartFormElement: HTMLFormElement): void => {
    const addToCartButton: HTMLButtonElement = addToCartFormElement.querySelector('.submit-order');
    addToCartButton.disabled = true;
    addToCartButton.classList.add('disabled');
    const quantityInput: HTMLInputElement = addToCartFormElement.querySelector('.article__order-qty');
    quantityInput.disabled = true;
    quantityInput.parentElement.classList.add('mdc-text-field--disabled');
}
